import _ from 'lodash';
import { createSelector } from 'reselect';
import { getLanguage, getStateSlice } from './selectors';

function translate(language, stockHierarchyEntry) {
  const entryForLanguage = stockHierarchyEntry.get('info').get(language);
  if (!entryForLanguage) {
    throw new Error(
      `No translations available for stock hierarchy with language '${language}'`
    );
  }
  return {
    code: stockHierarchyEntry.get('code'),
    name: entryForLanguage.get('name'),
    slug: entryForLanguage.get('slug')
  };
}

const getStockHierarchyMap = state => getStateSlice(state).get('firstStorage');
const getMarketStockHierarchyMap = state =>
  getStateSlice(state).get('marketFirstStorage');

export const getStockHierarchy = createSelector(
  getStockHierarchyMap,
  stockHierarchyMap => stockHierarchyMap.toList()
);

export const getMarketStockHierarchy = createSelector(
  getMarketStockHierarchyMap,
  stockHierarchyMap => stockHierarchyMap.toList()
);

export const getStockHierarchyTranslated = createSelector(
  getLanguage,
  getStockHierarchy,
  (language, stockHierarchy) =>
    stockHierarchy.map(entry => translate(language, entry))
);

export const getStockHierarchyByCodeTranslated = code => {
  return createSelector(
    getLanguage,
    getStockHierarchyMap,
    (language, stockHierarchyMap) => {
      if (_.isUndefined(code)) {
        return null;
      }
      const entryWithCode = stockHierarchyMap.get(code);
      return translate(language, entryWithCode);
    }
  );
};
